import React from 'react'
import "../Modal/Signup.css"

const Signup = ({ onClose }) => {
    return (

        <div className="modal-overlay flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0 ">
             
        
            <div className="modal-content  relative w-full  border-b-4 border-[#fe1818] bg-white rounded-lg shadow dark:border sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                  <button className="close-btn" onClick={onClose}>
                X
            </button>
                <div className="p-6 space-y-4 md:space-y-6 sm:p-8 text-start">
                    <h1 className="text-xl font-bold leading-tight tracking-tight text-white md:text-2xl dark:text-white">
                        Create an account
                    </h1>
                    <form className="space-y-4 md:space-y-6" action="#">
                        <div>
                            <label
                                htmlFor="email"
                                className="text-white block mb-2 text-start text-sm font-medium  dark:text-white"
                            >
                                Your email
                            </label>
                            <input
                                type="email"
                                id="email"
                                placeholder="name@earthtechindia.com"
                                required
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="password"
                                className="text-white block mb-2 text-sm font-medium  dark:text-white"
                            >
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                placeholder="••••••••"
                                required
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="confirm-password"
                                className="text-white block mb-2 text-sm font-medium dark:text-white"
                            >
                                Confirm password
                            </label>
                            <input
                                type="password"
                                id="confirm-password"
                                placeholder="••••••••"
                                required
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                            />
                        </div>
                        <div className="flex items-start">
                            <div className="flex items-center h-5">
                                <input
                                    id="terms"
                                    type="checkbox"
                                    className="w-4 h-4 border border-gray-300 rounded-sm bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600"
                                    required
                                />
                            </div>
                            <div className="ml-3 text-sm">
                                <label
                                    htmlFor="terms"
                                    className="text-white font-light  dark:text-gray-300"
                                >
                                    I accept the{" "}
                                    <a
                                        href="#"
                                        className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                                    >
                                        Terms and Conditions
                                    </a>
                                </label>
                            </div>
                        </div>
                        <button
                            type="submit"
                            className="w-full text-white focus:ring-4 focus:outline-none font-medium rounded-sm text-sm px-5 py-2.5 text-center"
                        >
                            Create an account
                        </button>
                    </form>
                      <div class="auth-social w-full">
                            <div class="auth-divider flex items-center my-4">
                                <div class="flex-1 border-t border-gray-300 mx-2"></div>
                                <span class="auth-divider-text">OR</span>
                                <div class="flex-1 border-t border-gray-300 mx-2"></div>
                            </div>
                            <div class="auth-provider">
                              
                                <a href="#"
                                    class="social-auth-with-google mb-3 flex  justify-center items-center text-start p-2 border rounded w-full">
                                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        class="w-8 h-8 mr-6">
                                        <path
                                            d="M30.0014 16.3109C30.0014 15.1598 29.9061 14.3198 29.6998 13.4487H16.2871V18.6442H24.1601C24.0014 19.9354 23.1442 21.8798 21.2394 23.1864L21.2127 23.3604L25.4536 26.58L25.7474 26.6087C28.4458 24.1665 30.0014 20.5731 30.0014 16.3109Z"
                                            fill="#4285F4" />
                                        <path
                                            d="M16.2863 29.9998C20.1434 29.9998 23.3814 28.7553 25.7466 26.6086L21.2386 23.1863C20.0323 24.0108 18.4132 24.5863 16.2863 24.5863C12.5086 24.5863 9.30225 22.1441 8.15929 18.7686L7.99176 18.7825L3.58208 22.127L3.52441 22.2841C5.87359 26.8574 10.699 29.9998 16.2863 29.9998Z"
                                            fill="#34A853" />
                                        <path
                                            d="M8.15964 18.769C7.85806 17.8979 7.68352 16.9645 7.68352 16.0001C7.68352 15.0356 7.85806 14.1023 8.14377 13.2312L8.13578 13.0456L3.67083 9.64746L3.52475 9.71556C2.55654 11.6134 2.00098 13.7445 2.00098 16.0001C2.00098 18.2556 2.55654 20.3867 3.52475 22.2845L8.15964 18.769Z"
                                            fill="#FBBC05" />
                                        <path
                                            d="M16.2864 7.4133C18.9689 7.4133 20.7784 8.54885 21.8102 9.4978L25.8419 5.64C23.3658 3.38445 20.1435 2 16.2864 2C10.699 2 5.8736 5.1422 3.52441 9.71549L8.14345 13.2311C9.30229 9.85555 12.5086 7.4133 16.2864 7.4133Z"
                                            fill="#EB4335" />
                                    </svg>
                                    Sign Up with Google
                                </a>
                                
                            </div>
                        </div>

                </div>
               
            </div>
          
        </div>

    );
};

export default Signup
